module.exports = __webpack_public_path__ + "img/3.c856b1d7.svg";